import { Base, withResponsiveOptions } from '@studiometa/js-toolkit';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

/**
 *
 */
export default class SlideComplementaire extends withResponsiveOptions(Base) {
  /**
   * Config.
   */
  static config = {
    name: 'SlideComplementaire',
  };

  /**
   *
   */
  mounted() {
    this.swiper = new Swiper(this.$el, {
      modules: [Pagination],
      spaceBetween: 0,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        1024: {
          enabled: false,
        },
      },
    });
  }

  /**
   * Handle window resize event.
   * @param {object} props The resize event properties
   * @param {number} props.width The current window width
   */
  resized(props) {
    if (props.width >= 1024 && this.swiper) {
      this.swiper.setTranslate(0);
    }
  }
}
